import React from 'react';
import Inner from './Inner';
import Login from './Login';
import getstartedimage from '../images/get-started-image.png';

const Getstarted = () => {
  return (
    <div className="hero">
      <Inner>
        <div>
          <h1>Get started with your players card.</h1>
          <p>Generate your own dribbbler player card by signing in below. Stats are based on your last 100 shots.</p>
          <Login/>
        </div>
        <div>
          <div>
            <img src={getstartedimage} alt="preview of dribbbler cards"/>
          </div>
        </div>
      </Inner>
    </div>
  )
}

export default Getstarted;